import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PlayersService } from '../../../../shared/services/players/players';
import { GameInfoService } from '../../../../shared/services/games/game-info';

import { TmpWtPlayerInfo } from '../../../../shared/components/templates/tmp-wt-player-info/tmp-wt-player-info';
import { Subscription, timer } from 'rxjs';
import { UnionService } from '../../../../shared/services/union/union-service';
import { AllStatus } from '../../../../core/services/status/all-status';

import { RdGameService } from '../../../../shared/services/games/rd-game';
import { TranslatePipe } from '@ngx-translate/core';
import { ListQuest } from '../../../../shared/services/lists/list-quest';
import { DowntimeWindow } from '../../../../shared/dialogs/downtime-window/downtime-window';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ExitService } from '../../../../core/services/exit/exit.service';

import { ListRoles } from '../../../../shared/services/lists/list-roles';
import { ConfigurationService } from '../../../../core/services/configs/configuration';
import { ProgressPlayerHelper } from '../../../../features/progress-player/progress-player-helper';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FieldBuilder } from '../../../../shared/services/fields/field-builder';

@Component({
  selector: 'app-waiting-game',
  imports: [TmpWtPlayerInfo,TranslatePipe, MatFormFieldModule, MatInputModule], 
  templateUrl: './waiting-game.html',
  styleUrl: './waiting-game.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WaitingGame implements OnInit, OnDestroy {
  activatedRoute = inject(ActivatedRoute);
  
  rdUse = inject(RdGameService);
  players = inject(PlayersService);
  gameInfo = inject(GameInfoService);
  union = inject(UnionService);
  allStatus = inject(AllStatus);
  router = inject(Router);

  quests = inject(ListQuest);
  roles = inject(ListRoles);

  subscription: Subscription;
  subscriptionDW: Subscription;
  subscriptionCM: Subscription;
  whenRefresh$ = timer(0, 1000);
  uuid: string;
  readonly dialog = inject(MatDialog);
  exit = inject(ExitService);

  config = inject(ConfigurationService);
  fieldBuilder = inject(FieldBuilder);
  progressHelper = inject(ProgressPlayerHelper);

  constructor( private ref: ChangeDetectorRef){}

  ngOnInit(): void {
    //this.allStatus.textSpinner = '';
    //this.allStatus.setDisplayProgressSpinner(false);
    
    this.uuid = this.activatedRoute.snapshot.paramMap.get('id') as string;
    this.allStatus.setChangeUuId(this.uuid);
    this.allStatus.setEditUserInWaiting(true);

    this.allStatus.clearCards();
    if(typeof this.players.player === 'undefined'){
      this.players.getPlayerStorage();
    }


        
    this.activatedRoute.data.subscribe(({ room, players })=>{

      // if(room.type === 'quest'){
      //   this.quests.quests = [];
      //   this.quests.getAllQuests();
      // }

      // if(room.type === 'role'){
      //   this.roles.roles = [];
      //   this.roles.getAllRoles();
      // }

      if(!this.config.configuration?.config?.is_demo){
        this.progressHelper.getWithStorage();
      }

      this.players.players = players.players;
      this.gameInfo.gameInfo = room;
      this.fieldBuilder.loadPlayingField(this.gameInfo.gameInfo.room.not_empty);


      if(this.players.player.is_starter){
        if(!this.allStatus.isEditUserInWaiting){
          this.players.changeFieldPlayers();      
          let games = {...room.room, players: this.players.players };
          void this.rdUse.createGame(games).catch((error) =>{
            console.error(`Failed to create Firebase game for room ${this.uuid}`, error);
          });
          
        }
      }else{
        
        void this.rdUse.updateGameById(
          this.uuid,
          this.gameInfo.gameInfo.room,
          this.players.player,
          this.players.players,
        ).catch((error) =>{
          console.error(`Failed to sync players for room ${this.uuid}`, error);
        });
        
      }
      this.rdUse.gameInfoById(this.uuid);
      
      if(this.gameInfo.gameInfo.room.maximum_players > 1){
        this.updateAllInfo();
      }
    });

    this.subscriptionDW = this.allStatus.downTime$.subscribe((follow: any)=>{
      if(follow){
        const dialogConfig = new MatDialogConfig();
        dialogConfig.panelClass = 'nutri-templs';
        dialogConfig.backdropClass = 'nutri-templs-backdrop';

        const dialogRef = this.dialog.open(DowntimeWindow, dialogConfig);
        dialogRef.afterClosed().subscribe(result=>{
          this.players.detelePlayerByPage(this.activatedRoute.snapshot.paramMap.get('id') as string);
          this.exit.exitSystem();
        });
      }
    });

    

    this.subscriptionCM = this.allStatus.refreshNotValid$.subscribe((action: boolean)=>{
      if(action){
        this.players.completionWork(this.activatedRoute.snapshot.paramMap.get('id') as string);
        this.exit.closeSystem();
      }
    });
    
  }

  ngOnDestroy(){
    // this.allStatus.isEditUserInWaiting = false;
    if(this.subscription){
      this.subscription.unsubscribe();
    }
    if(this.subscriptionDW){
      this.subscriptionDW.unsubscribe();
    }
    if(this.subscriptionCM){
      this.subscriptionCM.unsubscribe();
    }
    this.allStatus.setSelectRQ(0);
  }

  updateAllInfo(){
    this.subscription = this.whenRefresh$.subscribe(()=>{
      this.ref.markForCheck();
    });
  }

  stateGame(){
    if(this.gameInfo.gameInfo.room.stage_slug === 'inprogress'){
      if(this.players.player.is_ready){
        this.gameInfo.finishGame(this.activatedRoute.snapshot.paramMap.get('id') as string);
        if(this.gameInfo.gameInfo.room.maximum_players > 1 ){
          this.router.navigate([`/coop-game/${this.activatedRoute.snapshot.paramMap.get('id') as string}`]);
        }else{
          this.router.navigate([`/single-game/${this.activatedRoute.snapshot.paramMap.get('id') as string}`]);
        }        
        
      }else{
        this.router.navigate(['/step-one']);
      }
    }
  }

  changeAvailable(available_rqs: Array<number> = [101,102,103,104,105,106,107,108,109,110,111,112,113,114,115,116,117,118,119,120,121,122,123,124]){
    let arrayRQ = available_rqs;
    if(this.players.player.rq_id !== null){
      arrayRQ.unshift(this.players.player.rq_id);
    }
    return arrayRQ;
  }

}
